import React from "react"
import autobind from "class-autobind"
import * as jobHelper from "../../../helpers/jobHelper"
import strings from "../../../localization/strings"
import { ISchedulePatternTemplate, IWorkPoolEmployee } from "../../../models"
import AppStateStore from "../../../stores/AppStateStore"
import * as api from "../../../api"
import ShiftCandidateShortList from "./ShiftCandidateShortList"
import ShiftSubmittedCandidates from "./ShiftSubmittedCandidates"
import ShiftRequestedCandidates from "./ShiftRequestedCandidates"

interface IProps {
    readonly?: boolean
    assignPatternTemplate: ISchedulePatternTemplate
    handleChooseEmployee(employee: IWorkPoolEmployee): void
    assignEmployeeToShift?: (employee: IWorkPoolEmployee) => void
    replaceSchedulePatternTemplate(schedulePatternTemplate: ISchedulePatternTemplate): void
}
interface IState {
    workPoolEmployees: IWorkPoolEmployee[]
}

export default class ShiftWorkerPool extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            workPoolEmployees: this.props.assignPatternTemplate.WorkPoolEmployees,
        }
        autobind(this)
    }

    shortListCandidate(employeeId: string) {
        api.shortListSelectedShiftCandidates(this.props.assignPatternTemplate.Id, { userIds: [employeeId] })
            .then((res) => {
                this.setState({ workPoolEmployees: res.data.WorkPoolEmployees }, () => {
                    AppStateStore.setProgressSnackbarContent(strings.Successfully_shortlisted)
                    this.props.replaceSchedulePatternTemplate &&
                    this.props.replaceSchedulePatternTemplate(res.data)
                })
            })
            .catch(err =>
                AppStateStore.setProgressSnackbarContent(err.response.data.message)
            )
    }

    archiveCandidate(employeeId: string) {
        AppStateStore.setProgressSnackbarContent("loading")
        api.archiveWorkPoolShiftEmployee(this.props.assignPatternTemplate.Id, employeeId).then((res) => {
            this.setState({ workPoolEmployees: res.data.WorkPoolEmployees }, () => {
                AppStateStore.setProgressSnackbarContent(strings.Successfully_archived)
                this.props.replaceSchedulePatternTemplate &&
                this.props.replaceSchedulePatternTemplate(res.data)
            })
        })
    }

    declineCandidateOnJob(userId: string, declineNote: string) {
        AppStateStore.setProgressSnackbarContent("loading")
        api.declineCandidateOnShift(userId, this.props.assignPatternTemplate.Id, declineNote).then((res) => {
            this.setState({ workPoolEmployees: res.data.WorkPoolEmployees }, () => {
                AppStateStore.setProgressSnackbarContent(strings.Successfully_declined)
                this.props.replaceSchedulePatternTemplate &&
                this.props.replaceSchedulePatternTemplate(res.data)
            })
        })
    }


    render() {
        return (
            <div className="user-detail-tab" style={{ padding: 30 }}>
                <ShiftCandidateShortList
                    readonly={this.props.readonly}
                    assignPatternTemplate={this.props.assignPatternTemplate}
                    shortListCandidates={jobHelper.getShortListCandidates(this.state.workPoolEmployees)}
                    archiveCandidate={this.archiveCandidate}
                    updateWorkPoolEmployeesList={(workPoolEmployees: IWorkPoolEmployee[]) => this.setState({ workPoolEmployees })}
                    replaceSchedulePatternTemplate={this.props.replaceSchedulePatternTemplate}
                    handleChooseEmployee={this.props.handleChooseEmployee}
                    assignEmployeeToShift={this.props.assignEmployeeToShift}
                />
                <ShiftSubmittedCandidates
                    readonly={this.props.readonly}
                    submittedCandidates={jobHelper.getSubmittedCandidates(this.state.workPoolEmployees)}
                    shortListCandidate={this.shortListCandidate}
                    assignEmployeeToShift={this.props.assignEmployeeToShift}
                />
                <ShiftRequestedCandidates
                    readonly={this.props.readonly}
                    requestedCandidates={jobHelper.getRequestedCandidates(this.state.workPoolEmployees)}
                    shortListCandidate={this.shortListCandidate}
                    declineCandidateOnJob={this.declineCandidateOnJob}
                    assignEmployeeToShift={this.props.assignEmployeeToShift}
                />
            </div>
        )
    }
}